export enum ColumnTypes {
    Text = "text",
    FavToggle = "fav-toggle",
    LatestAvailableSoftwareVersion = "latest-available-software-version",
    MachineName = "machine-name",
    Status = "status",
    DetailLink = "detail-link",
    DiscontinuedInfo = "discontinued",
    Date = "date",
    TextWithConditionalTooltip = "text-with-conditional-tooltip",
    Checkbox = "checkbox",
    Equipment = "equipment",
    Hidden = "hidden",
}

export enum InternalColumnTypes {
    TextAndDate = "text-and-date",
}
